module.exports = __webpack_public_path__ + "static/img/p7.ef57cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p7.png
// module id = ATn/
// module chunks = 0